import { createContext, useContext, useEffect, useState } from 'react';

const WindowContext = createContext<{
  windowWidth: number;
  breakpoints: Record<string, number>;
}>({
  windowWidth: 1280,
  breakpoints: {
    '2xs': 375,
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  },
});

export function WindowProvider({ children }: { children: React.ReactNode }) {
  // Here we default to a value on the server (where window is not defined)
  const [windowWidth, setWindowWidth] = useState(1280); // or any default value you prefer

  const breakpoints = {
    '2xs': 375,
    xs: 480,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
  };

  useEffect(() => {
    // This code will only run on the client, so window will be defined
    setWindowWidth(window.innerWidth);
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <WindowContext.Provider value={{ windowWidth, breakpoints }}>
      {children}
    </WindowContext.Provider>
  );
}

export function useWindowWidth() {
  const context = useContext(WindowContext);
  if (context === undefined) {
    throw new Error('useWindowWidth must be used within a WindowProvider');
  }
  return context;
}
